// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"GroupLevelAttributeList_tableHeader_BVhBr","capitalize":"GroupLevelAttributeList_capitalize_2p-PS"};